
import React from "react";
import LuissButton from "../../common_components/luiss_button/luiss_button";
import SocialList from "../../assets/social_list.svg"
import {Col, Container, DropdownButton, Row} from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ReactPlayer from "react-player";
import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    EmailShareButton,
    EmailIcon
} from 'react-share';
import ctc from "../../assets/ctclipboard.png";
import DoubleTemplateComponent
    from "../../containers/template_page/double_template_component/double_template_component";
import Moment from "react-moment";
import {insertHtml} from "../../utils/dom";
import './c5_blocco_news.scss';
import {columnLayout, extraSmallLayout} from "../../utils/device";
import isExternal from 'is-url-external';

const SVG_ID = "#svg_id";

class C5BloccoNews extends DoubleTemplateComponent {

    constructor(props) {
        super(props);

        this.state = {
            playing: false
        };

        this.requireInternationalization = true;
    };

    playVideo = () => {
        this.setState({
            playing: true
        });
    };

    mainCardRender(card, shareText) {
        const shareIconsProps = {
            logoFillColor: '#003a70',
            iconBgStyle: {fill: 'transparent'},
            size: 50
        };
        const shareUrl = isExternal(card.card_link_url) ?
            card.card_link_url : (window.location.host + card.card_link_url);

        const shareButtons = [
            <FacebookShareButton url={shareUrl} quote={shareText}>
                <FacebookIcon {...shareIconsProps} />
            </FacebookShareButton>,
            <TwitterShareButton url={shareUrl} quote={shareText}>
                <TwitterIcon {...shareIconsProps} />
            </TwitterShareButton>,
            <CopyToClipboard text={shareUrl}>
                {extraSmallLayout() ?
                    <i className="fas fa-link fa-lg"/>
                    :
                    <img src={ctc} alt="Luiss.it" className="complex-ui-ctc"/>
                }
            </CopyToClipboard>,
            <EmailShareButton url={shareUrl} subject={shareText}>
                <EmailIcon {...shareIconsProps} />
            </EmailShareButton>
        ];

        return (
            <Container fluid={true} className='card-container'>
                <Row>
                    {(card.video || card.image) &&
                        <Col {...columnLayout(6)} className="card-video-col">
                            {card.video ?
                                <ReactPlayer className="card-video"
                                             light={card.image ? card.image : true}
                                             url={card.video} controls={true}
                                             playing={this.state.playing}
                                             playIcon={!this.state.playing &&
                                                 <button className="card-video-button" onClick={this.playVideo.bind(this)}>
                                                     <div className="card-video-triangle"/>
                                                 </button>
                                             }/>
                            :
                                <img className="card-video" src={card.image} alt="luiss.it"/>
                            }
                        </Col>
                    }
                    <Col {...columnLayout((card.video || card.image) ? 6 : 12)} className="card-contents-col">
                        <div className='card-title'>
                            {card.card_title}
                        </div>
                        <div className='card-subtitle' {...insertHtml(card.card_subtitle)} />
                        {!extraSmallLayout() ?
                            <div>
                                <span className="card-social-net-section-title">SHARE:</span>
                                <span>
                                    <ul className="card-social-net-links-list">
                                        {shareButtons.map((button, index) => (
                                            <li className="social-icon" key={`social-button-${index}`}>{button}</li>
                                        ))}
                                    </ul>
                                </span>
                            </div>
                            :
                            <div>
                                <div className="social-share-shadow" />
                                <div className="social-share" />
                                <svg className="social-list-button">
                                    <use xlinkHref={`${SocialList}${SVG_ID}`} />
                                </svg>
                                <div className="dropup">
                                    <DropdownButton drop='up' variant="secondary"
                                                    id='dropdown-button-drop-up' key='up'
                                                    title="">
                                        {shareButtons.map((button, index) => (
                                            <li key={`social-button-${index}`}>{button}</li>
                                        ))}
                                    </DropdownButton>
                                </div>
                            </div>
                        }
                        <div className='card-date'>
                            <Moment date={card.card_date} format="D MMMM YYYY"/>
                        </div>
                        <a className='card-link' href={card.card_link_url}>
                            {card.card_link_title}
                        </a>
                    </Col>
                </Row>
            </Container>
        );
    }

    internationalComponentRender(data, t) {

        const settings = {
            dots: true,
            variableWidth: true,
            centerMode: false,
            rows: 1,
            infinite: (data.slider_items && data.slider_items.length && data.slider_items.length > 2),
            swipeToSlide: true,
            slidesToScroll: 1
        };

        const numCards = (data.card && data.card.length > 0) ? data.card.length : 0;

        return (
            <Container fluid={true} className="c5-blocco-news">
                <Row>
                    <Col {...columnLayout(5)}>
                        <div className='text-container'>
                            <div className='text-title'>{data.title}</div>
                            {data.subtitle &&
                                <div className='text-subtitle' {...insertHtml(data.subtitle)} />
                            }
                            {!extraSmallLayout() &&
                                <LuissButton url={data.btn_link}>{data.btn_title}</LuissButton>
                            }
                        </div>
                    </Col>
                    <Col {...columnLayout(7)} className={!extraSmallLayout() ? 'd-flex justify-content-end right-side-container' : 'mobile-content'}>
                        {numCards > 0 && this.mainCardRender(data.card[0])}
                    </Col>
                </Row>
                {data.slider_items &&
                    <Row>
                        <Col {...columnLayout(5)} />
                        <Col {...columnLayout(7)} className="slider-container">
                            <Slider {...settings}>
                                {data.slider_items.map((item, index) => (
                                    <div key={index} className="complex-ui-slider-item">
                                        <div className="complex-ui-slider-title">{item.title}</div>
                                        <div className="complex-ui-slider-date">
                                            <Moment date={item.date} format="D MMMM YYYY"/>
                                        </div>
                                        <div className="complex-ui-slider-link">
                                            <a href={item.link_url}>
                                                {item.link_title ? item.link_title : t("C5 news cta label")}
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </Col>
                    </Row>
                }
                {extraSmallLayout() &&
                    <Row>
                        <Col xs={12}>
                            <LuissButton url={data.btn_link}>{data.btn_title}</LuissButton>
                        </Col>
                    </Row>
                }
            </Container>
        )
    }
}

export default C5BloccoNews;
